<template>
    <div style="width: 100%; position: relative" >
        <div class="wobuListContainerPublic" :class="{listContainer100: inWindow, 
            hideIt: 1==2, 
            publicBundleFulled: $parent.fulled} ">
           
            <div class="bundleContent">
                 
                <div>
                  
                    <div :transfer-data="{
                        listIndex: listIndex, 
                        type: 'list', 
                        fromSub: false, 
                        draggedId: rootId, 
                        collabId: conts.collabId}" class="is-size-5 has-text-weight-bold has-text-dark listTitleBar" @dragstart="dragStart"  @dragend="dragEnd">
                        <div>
                            <div class="is-inline-block bundleHeader">
                                <div v-if="!$root.app.bundlesOpen" class="is-inline-block openBundleButton handCursor"><i :class="{'fa fa-angle-down' : openThisB, 'fa fa-angle-right': !openThisB}" @click="doBundleState"></i></div>
                                <div  class="is-size-7 is-pulled-right top5">
                                    <!-- <div class="top-7 has-text-coolGreen">PUBLIC</div> -->
                                    <!-- <div class="refreshIcon handCursor top7" @click="openHistory" style="margin-right: 35px" v-tooltip="'activity'"><i class="fas fa-stream"></i></div>
                                    <div class="refreshIcon handCursor top7" @click="(e) => {e.stopPropagation(); showGroup = true}" style="margin-right: 17px"  v-tooltip="'members'"><i class="fas fa-user-alt"></i></div>
                                    <div v-show="showGroup" class="groupDisplay top5">
                                        <div v-for="(item, i) in groupMembers" :key="i" :class="{'has-text-grey': item.active == '0', 'has-text-coolGreen': item.owner == item.id_CUSTOMER}">{{item.fName}} {{item.lName}}</div>
                                        <div v-if="collabMine"><button class="button xs is-coolGreen is-small top5" @click="addMembers">Manage</button></div>
                                    </div>
                                    <div class="refreshIcon handCursor top7" @click="refreshData"  v-tooltip="'refresh'"><i class="fa fa-sync-alt" style="margin-right: -1px"></i></div> -->
                                </div>
                              
                                <div class="is-inline-block has-text-coolGreen handCursor bundleHeaderLogo fourDots" style="top: 1px" @click="openBundleTree" >&nbsp;::</div>   <!-- :class="{red: hasDirtyChildren}" -->
                               
                                <div v-if="showBundleTree" class="bundleSubTree" @click="stopProp">
                                    <div v-if="hasDirtyChildren" class="is-size-7 has-background-dark pad5"><button class="button is-small is-black redBorder">Manage Share Updates</button></div>
                                    <span class="delete  bundleSubTreeX" @click="showBundleTree = false"></span>
                                    <div class="top5">
                                        <tree2 v-for="(item, index) in data.children" 
                                            :key="index" 
                                            :listName="item.listName" 
                                            :children="item.children" 
                                            :depth="0" 
                                            :id="item.id" 
                                            :aliasTgtId="item.aliasTgtId"
                                            :rootBundleId="conts.id"
                                            :isDirty="item.dirt"
                                            :beenShared="item.beenShared"
                                            :path="[]">
                                        </tree2>
                                        <div>&nbsp;</div>
                                    </div>
                                </div>
        <!-- Breadcrumbs -->
                               <!--  <i v-if="hasDirtyChildren" class="fas fa-cloud-upload-alt red rootHasDirty is-size-7"></i> -->
                               <!--  <div>{{info.p}}</div> -->
                                <div v-if="$root.app.movingAdding == conts.id"  class="is-loading2 is-inline "></div>
                                <div  class="is-inline noDrag" v-for="(name, i) in this.breadCrumbs" :key="i" @dragenter="crumbDragEnter(i, ...arguments)" @dragleave="crumbDragLeave(i, ...arguments)" @drop="subBundleDrop(name.id, i, name.aliasTgtId, ...arguments)">
        
                                     
                                    <div class="is-inline thickerText" ref="crumb">
                                       
                                        <span class="subBack" ref="bCrumb" @click="subBack(name.id, i)" :class="{'breadCrumbsRoot' : i==0, 'has-text-azGrey': i > 0, 'currentBreadCrumb': i==breadCrumbs.length-1, 'rootBreadCrumbNotCurrent': i==0 && rootIsCurrent && breadCrumbs.length > 1}">{{name.listName}}</span> 
                                        <span v-if="i < breadCrumbs.length -1" class="has-text-grey-light"> <span class="has-text-azGrey"> &gt; </span> </span>  
                                    </div>
                                </div>
                                
                               <!--  <i v-show="!inWindow && !$root.app.bundlesOpen" class="is-hidden-touch fa fa-window-maximize is-size-6 handCursor is-pulled-right" @click="$parent.openWindow(conts.id, listIndex, breadCrumbs[0].id)"></i>&nbsp; -->
                               
                                <div v-show="showImportedInfo" class="importedInfo is-size-7">
                                    <div v-show="sharedBy == ''" class="holder top25"></div>
                                    <div v-show="sharedBy != ''">
                                        Shared by: {{sharedBy}} <br>
                                        On: {{az.dateConvert(sharedOn)}}
                                        <button class="handCursor is-coolGreen is-small is-pulled-right top10" @click="navToSB">VIEW</button>
                                    </div>
                                </div>
    
                                <!-- <i v-show="data.imported && !data.importAcl" class="fas fa-cloud-download-alt has-text-coolGreen is-pulled-right right-10 is-size-7 handCursor top-5" @click="doImportedInfo"></i>
                                <i v-show="data.beenShared && !data.exportAcl" class="fas fa-cloud-upload-alt is-pulled-right right3 is-size-7  handCursor top-5" :class="{red: data.dirt > 0, 'has-text-coolGreen': !data.dirt}" @click="doOfferUpdatePush"></i>
                                <i v-show="data.importAcl || data.exportAcl" class="fas fa-users is-pulled-right right3 is-size-7  handCursor top-5" :class="{red: data.dirt > 0, 'has-text-coolGreen': !data.dirt}" @click="doOfferUpdatePush"></i> -->
                            </div>
                        </div>
    
                    </div>
                </div>
                <!-- <div v-show="$root.app.showContext" class="bundleContext">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce ut ligula libero. Phasellus posuere diam nec dui suscipit congue. Donec eget sapien at lacus malesuada rhoncus. Aliquam scelerisque magna sapien, et imperdiet sem dignissim id. Curabitur dictum erat ut sapien cursus, non sollicitudin nunc mattis. Praesent vitae diam a velit auctor auctor. Quisque fermentum purus justo, ac lobortis ipsum finibus id. Maecenas eu mauris tellus.</div> -->
               
                <div v-show="$parent.showContext" class="width100p">
                    
                    <div v-if="data.pubNote" ref="bNotesPubl"  class="bundleContext has-background-black top20" >
                   
                        <div v-html="conts.pubNote" v-linkified class="bundleContextNote"></div>
                     
                    </div>
                    <!-- <div  v-show="!data.pubNote" class="notesLabelPlaceholder handCursor" :class="{notesLabelPlaceholderInSingleView: $root.app.fulled}" @click="openEditContext">notes</div> -->
                </div>
               
               <transition name="slide" type="out-in">
                   
                    <div class="listBGcolor"  :class="{height100: inWindow}">
        <!-- subBundles -->
                    
                        <div ref="subBundleList" class="subBundleListPublic" @scroll="doOnScroll" style="padding-bottom: 2px" :class="{sortTrayOpen: sortTrayOpen}">
                            
                           <div class="anglesBt has-background-grey" v-show="breadCrumbs.length > 1" @click="upLevel"><i class="fas fa-angle-double-left has-text-white"></i></div>
                           <sub-bundle ref="subBundle" class="is-inline handCursor darkHover" v-for="(subBundle, theInd) in conts.children" :key="theInd" :subBundle="subBundle" :theInd="theInd" :bundleId="data.id" :aliasTgtId="data.aliasTgtId" :prevDrag="true"></sub-bundle>
                           
                        </div>
                        
                      
        <!-- bundle -->
                    <div v-show="$root.app.bundlesOpen || openThisB"  :class="{vh68: $parent.fulled}" class="posRelative">
                        <div class="wobuList" :class="{height100: $parent.fulled, whiteSpaceNormal: $root.app.fulled}" ref="items">
                            <div class="bundleHoverLeft" v-show="conts.items.length && !fulled" @mousedown="lMousePress" @mouseup="mouseRelease" :class="{scrollHoverCorrect: !scrollerVisible}"></div>
                            <div v-show="!conts.items.length && $root.app.showImages" class="bundleWatermark">{{conts.listName}}</div>
                           <!--  <div v-if="!inWindow && !conts.items.length" class="linksLabel is-inline-block has-text-grey-light is-size-6"><b>[ add miimus ]</b> </div> -->
                            <span v-if="!inWindow">&nbsp;</span>
                            <div class="wobuCardContainer" v-for="(item, index) in conts.items" :key=index>
                                 <card-shared v-bind:cardInfo="item" :isPublic="true" ref="card" :sponsored="index%3 == 0"></card-shared>
                            </div> 
                            <trans-drop-zone id="spinTarget" v-bind:itemIndex="conts.items.length" :style="[!$root.app.showImages ? {height: '63px'} : {}]"></trans-drop-zone> <!-- v-bind:listIndex="listIndex"  -->
                            <div class="bundleHoverRight inCMS" v-show="conts.items.length && !fulled" @mousedown="rMousePress" @mouseup="mouseRelease" :class="{scrollHoverCorrect: !scrollerVisible}"></div>
                        </div>
                        </div>
                    </div>  
    
                      
                </transition>
            </div>
             <div v-if="this.listIndex == az.page().currOpenWindow" class="bundleInWindow is-size-5 has-background-dark has-text-white">
                &nbsp;<span class="has-text-grey"><b>::</b></span> <span class="has-text-white"><b> {{rootName}} </b></span> <i class="fa fa-window-maximize is-size-6 handCursor" @click="$parent.closeWindow(conts.id, listIndex)"></i>&nbsp;
                <div class="is-size-7 has-text-white "><span style="position: relative; top: 3px">&nbsp;&nbsp;&nbsp;Currently Displayed in floating Window</span></div>
             </div>   
        </div>
    </div>
</template>

<script>
import UrlCard from './UrlCard.vue'
import CardShared from './CardShared.vue'
import Tree2 from './Tree2.vue'
import TransDropZone from './TransDropZone.vue'
import ModalNewSub from '../components/ModalNewSub'
import ModalEditContext from '../components/ModalEditContext'
import SubBundle from '../components/SubBundle'
import SubBundleDrop from '../components/SubBundleDrop'
import bFactory from '../shared/bundleFactory.js'
import { AZEventBus } from '../components/AZEventBus'
import { Drag, Drop } from 'vue-drag-drop'



export default {
    name: 'bundle',
    components: {UrlCard, TransDropZone, Drop, Tree2, SubBundle, SubBundleDrop, ModalEditContext, CardShared},
    props: {
        info: {
            type: Object,
            default: function(){ return {listName: '', items: [], branch: []}}
        },
        listIndex: Number,
        inWindow: {
            type: Boolean,
            default: false
        }
    },
    data: function(){
        return {
            dragging: false,
            breadCrumbs: [],
            data: {items: []},
            sortDirection: true,
            showBundleTree: false,
            rootName: '',
            az: az,
            bc: [],
            branch: [],
            showImportedInfo: false,
            sharedBy: '',
            sharedOn: '',
            sbId: '',
            notesOpen: false,
            showPrivate: false,
            //pbPlaceholder: true,
            pvPlaceholder: true,
            hasDirtyChildren: false,
            hideIt: false, 
            rootId: null,
            showGroup: false,
            collabMine: false,
            rootIsCurrent: true,
            sortTrayOpen: false,
            openThisB: false,
            ii: null,
            ii2: null
        }
    },
    mounted: function(){

        var self = this

       /*  if(this.importedBreadCrumbs){
            this.breadCrumbs = this.importedBreadCrumbs
        } else {
            this.breadCrumbs.push({listName: this.info.listName, id: this.info.id})
        } */
        if(!this.info){
            return
        }

        this.data = this.info 
        this.data.items.sort(function(a,b){ return a.p - b.p})   

        let bb = null

        bb = this.$root.app.bundles.find(e => {
            return e.id == this.data.branch[0]
        })

        if(bb != null){
            if(bb.hasDirtyBundles){
                this.hasDirtyChildren = true
            }
        }

        if(this.data.hasDirtyBundles){
            this.hasDirtyChildren = true
        } 
        
        

        AZEventBus.$on('bundleDeleted', this.bundleDeletedHandler)

        AZEventBus.$on('removeBundleFromCardsParents', this.removeBundleFromCardsParentsHandler)

        AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)

        AZEventBus.$on('subBundleTreeItemClicked', this.subBundleTreeItemClickedHandler)

/*         if(this.conts.pubNote == '') this.pbPlaceholder = true 
        else this.pbPlaceholder = false */
        
        if(this.conts.privNote == '') this.pvPlaceholder = true 
        else this.pvPlaceholder = false

       /*   */

   
        


        

    },

   

    beforeDestroy: function(){
        AZEventBus.$off('bundleDeleted', this.bundleDeletedHandler)

        AZEventBus.$off('removeBundleFromCardsParents', this.removeBundleFromCardsParentsHandler)

        AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)

        AZEventBus.$off('subBundleTreeItemClicked', this.subBundleTreeItemClickedHandler)
    },


    methods:{

        bundleDeletedHandler: function(msg){
            if(msg.id == this.conts.id && !this.conts.isRoot){
               this.upLevel()
            }
        },

        removeBundleFromCardsParentsHandler: function(msg){
            if(msg.id == this.conts.id){
               this.removeBundleFromCardsParents()
            }
        },

        closeAllMenusHandler: function(msg){
            this.showBundleTree = false
            this.showImportedInfo = false
            this.showGroup = false

            this.sharedBy = ''
            this.sharedOn = ''
            this.sbId = ''

            for(var i in this.$refs.subDropdowns){
                if(this.$refs.subDropdowns[i].classList)
                    this.$refs.subDropdowns[i].classList.add('hideIt')
            }
        },

        subBundleTreeItemClickedHandler: function(msg){
            if(this.conts.id == msg.rootBundleId){
                this.data = msg.b
                this.showBundleTree = false
            }
        },
        /* loadItems: function(){
            var self = this;

            function w(d){
               self.$root.app.movingAdding = false
               var cards = d.response.cards


               for(var i = 0; i < cards.length; i++){

                    var already = self.$root.app.cards.findIndex(e => {
                        return e.id == cards[i].id
                    })

                    if (already != -1)
                        continue

                    var ind;
                    var parents = JSON.parse(cards[i].parents) || []
                    cards[i].parents = JSON.parse(cards[i].parents)
                    cards[i].tags = JSON.parse(cards[i].tags) || []

                    if(self.$root.app.userAttrs.sub != cards[i].id_cog){
                      cards[i].myCard = false
                    } else {
                      cards[i].myCard = true
                    }

                    self.$root.app.cards.push(cards[i])
                    
                    for(var x = 0; x < parents.length; x++){

                      ind = self.$root.app.bundles.findIndex(e => {
                          return e.id == parents[x].id
                      })

                      if(ind != -1){
                          self.$root.app.bundles[ind].items.push({id: cards[i].id, p: parents[x].p, cardsIndex: self.$root.app.cards.length - 1, entryId: parents[x].entryId, id_cog: cards[i].id_cog})
                      }
                        
                    }

                    self.conts.items.sort(function(a,b){ return a.p - b.p});

                    //ratings

                    d.response.ratings.forEach(e => {
                        self.$root.app.ratings.push(e)
                    })

                    d.response.ratingsAvg.forEach(e => {
                        self.$root.app.ratingsAvg.push(e)
                    })

                    let cd = self.$root.app.cards[self.$root.app.cards.length - 1];

                    let myRatings = []
                    for(var l=0; l < d.response.ratings.length; l++){
                      if(d.response.ratings[l].id_CARDS == cd.id){
                        myRatings.push({collabId: d.response.ratings[l].id_COLLAB, rating:  d.response.ratings[l].rating})
                      }
                    }

                    let avgRatings = []
                    for(l=0; l < d.response.ratingsAvg.length; l++){
                      if(d.response.ratingsAvg[l].id_CARDS == cd.id){
                        avgRatings.push({collabId: d.response.ratingsAvg[l].id_COLLAB, rating:  d.response.ratingsAvg[l].rating})
                      }
                    }

                    cd.myRatings = myRatings;
                    cd.avgRatings = avgRatings;

                }  
                
                let toCh = self.$root.app.bundles.find(e => {
                    return e.id == self.conts.id
                })

                toCh.itemsLoaded = true

                let arr = d.response.tagUniverse
                let tu = {}
                arr.forEach(e => {
                    tu[e.tag] = e.tag
                })
                arr.forEach(e => {
                    self.$root.app.tagUniverse.push(e)
                })

            }

            function n(){
                self.$root.app.movingAdding = false
            }
            
            let al = this.data.aliasTgtId ? this.data.aliasTgtId : this.data.id;

            this.$root.app.movingAdding = this.data.id
            this.$root.app.apiClient.get('subs/data/bundle/' + al, {}, w, n)

        }, */
        refreshData: function(){
            this.$root.app.InitialDataLoad(true);
        },
        doOnScroll: function(){
            AZEventBus.$emit('closeAllMenus', null)
        },
        handleDragOver: function(data, event){
            if(data.type == 'list'){
                this.dragging = true;
                this.$parent.enableScrollHelpers()
            }
        },
        dragEnd: function(){
            this.dragging = false
            this.$parent.disableScrollHelpers()
        },
        doDrop: async function(data, event){

               /*  if(data.collabId && data.fromSub){
                    this.$root.app.showModalOK({message:'Moving bundles in and out of Collab bundles is restricted for now. Stay tuned.'})
                    this.dragging = false;
                    return
                } */
               

                if(data.collabId && data.fromSub){
                    if(await this.$root.app.checkDescendantsForForeign(data.draggedId)){
                        this.dragging = false
                        this.$root.app.showModalOK({message: 'This bundle has content contributed by other collab members. Please remove this content before moving the bundle out of the collab.'})
                        
                        return
                    }
                    /* this.$root.app.showModalOK({message: 'Removing bundles from collab bundle coming soon. Stay tuned'})
                    return */ 
                }
           
           
                let movedBundle = this.$root.app.bundles.findIndex((e) => {
                    return e.id == data.draggedId
                })

                var copyOfBundle,
                copyOfBundle = this.$root.app.bundles[movedBundle] 

                let openWindowId
                if(this.$parent.windowOpen){
                    openWindowId = this.$root.app.bundles[this.$parent.currOpenWindow].id
                    
                }

                //Move the bundle
                if(data.fromSub){
                    this.$root.app.bundleMover(data.bundleId, 'root', this.listIndex, copyOfBundle, this.$root.app, [data.bundleId], null, null, null, data.aliasTgtId, null)
                            /* parentId, targetId, targetIndex, bundle, app, branch, listIndex) */                         
                } else {
                    let rootId = copyOfBundle.branch[0]
                    copyOfBundle = this.$root.app.bundles.find(e => {
                        return e.id == rootId;
                    }) 
                   
                    let draggedListIndex = this.$root.app.treeNoInbox.findIndex(e => {
                        return e.id == rootId;
                    })

                    
                    this.$root.app.bundleMover('root', 'root', this.listIndex, copyOfBundle, this.$root.app, null, draggedListIndex, null, null, data.aliasTgtId, null)
                }

                //TODO fix this --reset open window 
                if(this.$parent.windowOpen){
                    let lInd = this.$root.app.treeNoInbox.findIndex(e => {
                        return e.id == openWindowId
                    })

                    this.$parent.openWindow(openWindowId, lInd, this.breadCrumbs[0].id)
                }

            this.dragging = false;
            this.$parent.disableScrollHelpers()
        },
        dragStart: function(data, e){
            if(this.conts.isRoot){
                this.$root.app.bundleDraggerText = this.conts.listName
            } else {
                this.$root.app.bundleDraggerText = this.breadCrumbs[0].listName
            }
            
            var img = document.getElementById('bundleDragger')
            e.dataTransfer.setDragImage(img, 0, 30);
            this.$parent.enableScrollHelpers()
        },

        //Load bundle from breadcrumbs:
        subBack: function(id, index, bypass){
            if((this.breadCrumbs.length < 2 || id == this.conts.id) && !bypass) return

            //this.breadCrumbs.splice(index + 1)

            this.data = this.$parent.bundles.find(e => { 
                return id == e.id
            })

            this.checkPlaceholders()

           
        },

        upLevel: function(){
            this.subBack(this.breadCrumbs[this.breadCrumbs.length -2 ].id, this.breadCrumbs.length - 2, true)
        },
        //

        //Load Sub Bundle:
        loadSub: function(b, ind){
            this.riseSubLabel(b, ind)
        },
        /* loadSubFromDropdown: function(b, ind, parent){
            this.riseSubLabel(b, ind)
        }, */
        riseSubLabel: function(b, ind){
            //console.log(b)
            //this.$refs.subLabel[ind].classList.add('subLabelRise')
            //setTimeout(() => {
           

           
            //this.$refs.subLabel[ind].classList.remove('subLabelRise')
            this.data = b
            this.checkPlaceholders()

           /*  if(this.conts.itemsLoaded != true && this.conts.isRoot == false){
                this.loadItems()
            } */


            //}, 200)
        },
        openEditContext: function(){
            this.$root.app.loadedModalComponent = ModalEditContext;
            let n = ''
            if(this.conts.pubNote)
                n = this.conts.pubNote.slice()
            this.$root.app.modalPropsObj = {callBack: this.updNotes, text: n } //this.$refs.bNotesPubl.innerText
            this.$root.app.showModal = true
        },
        //

        sortIt: function(){
          this.sortDirection  = !this.sortDirection;
          if(this.sortDirection)
            this.data.items.sort(function(a,b){ return a.p - b.p})
          else
            this.data.items.sort(function(a,b){ return b.p - a.p})
        },
        sort: function(){
            this.data.items.sort(function(a,b){ return a.p - b.p})
        },
        shareIt: function(){
            this.sortTrayOpen = false
            this.$root.app.doShowModal('ModalShare', {id: this.conts.id, branch: this.conts.branch})
        },
       /*  newSubBundle: function(){
            this.$root.app.loadedModalComponent = ModalNewSub;
            this.$root.app.modalPropsObj = {callBack: this.saveSub, collabId: this.conts.collabId, selectedId: this.conts.id, selectedAliasId: this.data.aliasTgtId}
            this.$root.app.showModal = true
        }, */
       /*  saveSub: function(bundleName){
           var self = this;
           var thisBundle;

           function w(data){
                self.$root.app.movingAdding = false
                self.$root.app.closeModal()

                let bId = data.response
                let newBranch = self.conts.branch.concat([bId])
                let b = bFactory(bId, false, bundleName, newBranch)
                b.collabId = self.conts.collabId
                b.id_cog = self.$root.app.userAttrs.sub
                self.$root.app.bundles.push(b);
                thisBundle = self.$root.app.bundles.find((e) => {
                    return e.id == self.conts.id
                })
                thisBundle.children.push(b)
             }

            function n(){
                self.$root.app.movingAdding = false
                self.$root.app.closeModal()
                self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support.'})
            }

            this.$root.app.movingAdding = this.conts.id
            self.$root.app.doShowModal('FullSpinner', {})
            self.$root.app.apiClient.post('subs/data/bundle', {name: bundleName, isRoot: false, targetBundle: self.conts.aliasTgtId || self.conts.id, p: null, collabId: this.conts.collabId}, w, n);
        }, */
        deleteBundle: function(){
            //this is handled in ModalNewSub Component
        },
       /*  editBundle: function(){
            this.sortTrayOpen = false
            this.$root.app.loadedModalComponent = ModalNewSub;

            var selectedId
            var selectedAliasId

            if(this.conts.branch.length == 1){
              selectedId = 0;
              selectedAliasId = 0
            } else {
                selectedId = parseInt(this.conts.branch[this.conts.branch.length - 2])
                selectedAliasId = parseInt(this.conts.branch[this.conts.branch.length - 2])
            }

            this.$root.app.modalPropsObj = {callBack: this.doEdit, bundleName: this.conts.listName, createOrEdit: 'edit', bundleId: this.conts.id, sub: !this.conts.isRoot, collabId: this.conts.collabId, bParent:  this.breadCrumbs.length > 1 ? parseInt(this.breadCrumbs[this.breadCrumbs.length - 2].id ): null, aliasTgtId: this.conts.aliasTgtId, selectedId: selectedId, selectedAliasId: selectedAliasId, me: this.conts.id }
            this.$root.app.showModal = true
        }, */
        /* doEdit: function(bundleName, xxx, yyy, zzz, wrapperId, aliasTgtId, selectedCollabId, doChangeParent){
            var self = this
            
            function w(){
                let thisBundle = self.$root.app.bundles.find((e) => {
                    return e.id == self.conts.id;
                })
                thisBundle.listName = bundleName;

                setTimeout(moveIt, 100)
            }

            function n(){
                self.$root.app.showModalOK({message: 'There was an error processing your request, please try again or contact support.'})
            }
            self.$root.app.apiClient.put('subs/data/bundle', {listName: bundleName, targetId: self.conts.aliasTgtId || self.conts.id, collabId: self.conts.collabId, oldName: self.conts.listName}, w, n);

            
            let parentId = null
            let listIndex = null
            if(this.conts.branch.length == 1){
                parentId = 'root'
                listIndex = this.$root.app.treeNoInbox.findIndex(e => {
                    return e.id == parseInt(this.conts.branch[0])
                })
            } else {
                parentId = this.conts.branch[this.conts.branch.length - 2]
            }

            async function moveIt(){
                if(doChangeParent){
                    var copyOfBundle = self.$root.app.bundles.find((e) => {
                            return e.id == self.conts.id
                    })

                copyOfBundle = JSON.parse(JSON.stringify(copyOfBundle))

                if(selectedCollabId != self.conts.collabId && (selectedCollabId && self.conts.collabId)){
                        self.$root.app.closeModal()
                        setTimeout(function(){
                            self.$root.app.showModalOK({message: "You cannot put a collab bundle into another collab bundle."})
                        },20)
                    
                        return;
                    
                }

                if(selectedCollabId != self.conts.collabId && selectedCollabId){
                    self.$root.app.closeModal()

                    var par = self.$root.app.bundles.find(e => {
                        return e.id == parentId
                    })

                    var parIndex = self.$root.app.treeNoInbox.findIndex(e => {
                        return e.id == parIndex
                    })

                    setTimeout(function(){
                        self.$root.app.doShowModal('ModalDragbtoc', {message: 'You are moving a bundle into a collab bundle. Would you like to move it, or create a copy of it.', 
                        callBack: self.doDragBIntoCollab,
                        payload: {
                            index: 0, 
                            aliasTgtId: aliasTgtId, 
                            collabId: selectedCollabId,
                            targetId: aliasTgtId || wrapperId, 
                            data: {
                                draggedId: self.conts.id,
                                bundleId: parentId,
                                listIndex: parIndex
                            }, 
                            parentId: self.conts.aliasTgtId || self.conts.id, 
                            event: event, 
                            branch: par? par.branch : [],
                            //doLevelUp: true,
                            levelUp: self.upLevel
                        },
                        fromTreeMover: true
                        })
                    },20)
                    return
                } else if(selectedCollabId != self.conts.collabId && self.conts.collabId){
                    
                    if(self.conts.isRoot == true){
                        self.$root.app.closeModal()
                        setTimeout(function(){
                            self.$root.app.showModalOK({message: 'Putting collab bundles into other bundles is restricted for now. Stay tuned.'})
                            },20)
                        return
                    } else {
                        
                        if(await self.$root.app.checkDescendantsForForeign(self.rootId)){
                            self.$root.app.closeModal()
                            setTimeout(function(){
                                self.$root.app.showModalOK({message: 'This bundle has content contributed by other collab members. Please remove this content before moving the bundle out of the collab.'})
                            },20)
                            return
                        }
                     
                    }

                }

                self.$root.app.bundleMover(parentId, aliasTgtId || wrapperId, 0, copyOfBundle, self.$root.app, self.conts.branch, listIndex, null, null, self.conts.aliasTgtId, selectedCollabId, self.upLevel)
                
                }
            }
        }, */
        toggleSortOpen: function(){
            this.sortTrayOpen = !this.sortTrayOpen
        },
        removeBundleFromCardsParents: function(){
            for(let i=0; i < this.conts.items.length; i++){
                let card = this.$root.app.cards[this.conts.items[i].cardsIndex]
                let ind = card.parents.findIndex(e => {
                    return e.id == this.conts.id
                })
                card.parents.splice(ind, 1)
            }
        },
     

    
        openHistory: function(){
            this.$root.app.openHistory(this.breadCrumbs[0].id, this.conts.collabId, this.breadCrumbs[0].listName, this.listIndex)
        },

     
      
        openBundleTree: function(event){
            if(this.info.children.length){
                event.stopPropagation();
                this.showBundleTree = true
            }
        },
        stopProp: function(event){
            event.stopPropagation();
        },

        doImportedInfo: function(event){
            event.stopPropagation();
            this.showImportedInfo = true

            var self = this

            function w(d){
                az.addRemSpinner(false, 'class', 'holder')
                self.sharedBy = d.sharedBy
                self.sharedOn = d.sharedOn
                self.sbId = d.sbId
            }
            function n(){
                az.addRemSpinner(false, 'class', 'holder')
            }

            az.addRemSpinner(true, 'class', 'holder')
            this.$root.app.apiClient.get('subs/data/importeddata/' + this.conts.shareId, {}, w, n)
        },

        doOfferUpdatePush(){
            var self = this

            if(this.hasDirtyChildren){
                var b = this.$root.app.treeNoInbox.find(e => {
                    return e.id == this.breadCrumbs[0].id
                })
                self.$router.push({name: 'sb', params: {theBundle: [b], isPush: true}})
            } else {
                this.$root.app.showModalOK({message: 'There are no additions to any shared bundles that require updating.'})
            }
           
            
        },

        navToSB: function(){
            this.$router.push('/sb' + '?s=' + this.sbId)
        },
       
        expandBundle: function() {
            this.openThisB = true
        },
        collapseBundle: function() {
            this.openThisB = false
        },
        doBundleState: function(){
            this.openThisB = !this.openThisB
        },

        toggleFulled: function(){
            this.sortTrayOpen = false
            if(this.$root.app.fulled){
                this.$root.app.fulled = false
                this.$root.app.fulledBundle =  null
            } else {
                this.$root.app.fulled = true
                this.$root.app.fulledBundle = this.conts.branch[0]
                document.getElementById('listsHolder').scrollTo(0,0)
            }
        },
        updNotes: function(pubNew){

            let self = this;
            let changes = {}

            let privNew = this.$refs.bNotesPriv.innerText
           /*  let pubNew = this.$refs.bNotesPubl.innerText */

            //if(pubNew == '' || pubNew == undefined) this.pbPlaceholder = true
            if(privNew == '') this.pvPlaceholder = true

            if(this.conts.privNote != privNew)
                changes.privNote = privNew

            if(this.conts.pubNote != pubNew && pubNew != 'nothing')
                changes.pubNote = pubNew

            if(changes.hasOwnProperty('privNote') || changes.hasOwnProperty('pubNote')){
                
                function w(){
                    self.$root.app.movingAdding = false
                    let thisBundle = self.$root.app.bundles.find((e) => {
                        return e.id == self.conts.id;
                    })
      
                    thisBundle.privNote = privNew
                    thisBundle.pubNote = pubNew
                }

                function n(){
                    self.$root.app.movingAdding = false
                    self.$root.app.showModalOK({message: 'There was an error processing your request. Please try again or contact support.'})
                }

                this.$root.app.movingAdding = this.conts.id
                this.$root.app.apiClient.put('subs/data/updbundlenotes', {changes: changes, bundleId: this.conts.id, collabId: this.conts.collabId, aliasTgtId: this.conts.aliasTgtId || this.conts.id}, w, n);
                
            }
        },

        pbPlaceholderFocus: function(){
           //this.pbPlaceholder = false
        },

        pvPlaceholderFocus: function(){
           this.pvPlaceholder = false
        },

        checkPlaceholders: function(){
           /*  if(this.conts.pubNote == '') this.pbPlaceholder = true 
            else this.pbPlaceholder = false */
            
            if(this.conts.privNote == '') this.pvPlaceholder = true 
            else this.pvPlaceholder = false
        },
        /*collabMine: function(){
            
             var rootIdCog
            if(this.info.isRoot && !this.info.isAlias){
                return this.info.id_cog == this.$root.app.userAttrs.sub
            } else if(this.info.isRoot && this.info.isAlias) {
               for(var x=0; x<this.$root.app.bundles.length; x++){
                   if(this.$root.app.bundles[x].id == this.data.aliasTgtId){
                       rootIdCog = this.$root.app.bundles[x].id_cog
                       break;
                   }
               }
               
                return rootIdCog == this.$root.app.userAttrs.sub;
            } else {
                
                for(var x=0; x<this.$root.app.bundles.length; x++){
                   if(this.$root.app.bundles[x].aliasTgtId == this.data.branch[0].id){
                       rootIdCog = this.$root.app.bundles[x].id_cog
                       break;
                   }
               }

                return rootIdCog == this.$root.app.userAttrs.sub;
            } 
        },*/
        addMembers: function(){
            let memberArr = [];
            this.$root.app.groupMembers.forEach(e => {
                if(e.id_acl == this.data.collabId && e.id_CUSTOMER != this.$root.app.userAttrs.sub){
                    memberArr.push(e.id_CUSTOMER)
                }
            })

            // TODO FIND ID OF COLLABROOT BUNDLE TAKING ALIAS INTO ACCOUNT AND SEND IN BELOW REQUEST
            var rootCollabId
            if(this.info.isRoot && !this.info.isAlias){
                rootCollabId = this.info.id
            } else if(this.info.isRoot && this.info.isAlias) {
                rootCollabId = this.info.aliasTgtId
            } else {
                for(var x=0; x < this.$root.app.bundles.length; x++){
                   if(this.$root.app.bundles[x].aliasTgtId == this.data.branch[0].id){
                       rootCollabId = this.$root.app.bundles[x].id
                       break;
                   } 
               }

            }
          
            this.$root.app.doShowModal('ModalAddCollabMembers', {members: memberArr, groupId: this.data.collabId, rootCollabId: rootCollabId, callBack: this.afterMembersAdded})
        },
        afterMembersAdded: function(){
            this.$root.app.closeModal()
        },

        rMousePress: function(){
            this.scrollRight()
        },

        lMousePress: function(){
            this.scrollLeft()
        },

        mouseRelease: function(){
            this.down = false;
            window.clearInterval(this.ii)
            window.clearInterval(this.ii2)
        },

        scrollRight: function(){
            var self = this            
            self.ii = setInterval(function() { self.$refs.items.scrollBy(5, 0) }, 7 )
    
        },

        

        scrollLeft: function(){
            var self = this
            self.ii2 = setInterval(function(){self.$refs.items.scrollBy(-5, 0)}, 7 )

        }


    },  
    computed: {
        scrollerVisible: function(){
            return this.$el.scrollWidth > this.$el.clientWidth;
        },

        conts: function(){
            //this.data.items.sort(function(a,b){ return a.p - b.p})
            
           
            this.rootName = this.info.listName;
            this.breadCrumbs = []
            if(!this.isRoot){
                if(this.data.branch){
                    if(this.data.branch.length){
                        for(var i = 0; i < this.data.branch.length; i++){
                            var b;
                            for(var x=0; x < this.$parent.bundles.length; x++){
                                if(this.$parent.bundles[x].id  == this.data.branch[i]){
                                    b = this.$parent.bundles[x];
                                    break;
                                }
                            }

                            if(i==0) 
                                this.rootId = b.id
                            this.breadCrumbs.push({listName: b.listName, id: b.id, aliasTgtId: b.aliasTgtId})
                        }
                    }
                }
            } else {
                this.rootId = this.conts.id
            }
            this.showPrivate = false

            ////

             var rootIdCog
            if(this.info.isRoot && !this.info.isAlias){
                this.collabMine = this.info.id_cog == this.$root.app.userAttrs.sub
            } else if(this.info.isRoot && this.info.isAlias) {
               for(var x=0; x<this.$parent.bundles.length; x++){
                   if(this.$parent.bundles[x].id == this.data.aliasTgtId){
                       rootIdCog = this.$parent.bundles[x].id_cog
                       break;
                   }
               }
               
                this.collabId = rootIdCog == this.$root.app.userAttrs.sub;
            } else {
                
                for(var x=0; x<this.$parent.bundles.length; x++){
                   if(this.$parent.bundles[x].aliasTgtId == this.data.branch[0].id){
                       rootIdCog = this.$parent.bundles[x].id_cog
                       break;
                   }
               }

                this.collabMine = rootIdCog == this.$root.app.userAttrs.sub;
            }
        



            ////
            if(!this.info.isRoot){
                this.rootIsCurrent = false
            } else {
                this.rootIsCurrent = true
            }
           

            return this.data || {items: [], branch: [-1]}
        },
        groupMembers: function(){
            return this.$root.app.groupMembers.filter(e => { return e.id_acl == this.data.collabId})
        }
        
        
    },
    watch:{
        info: function(){

            this.data = this.info;
           
        }
    }
}
</script>